// import * as FileSystem from '../../../expo-file-system'
// import getFullUriFileSystemUtil from '../get-full-uri'
import { logUtil } from 'packages/src'

async function existsFileSystemUtil (uri) {
  try {
    // const fullUri = getFullUriFileSystemUtil(uri)
    // logUtil('').debug(`existsFileSystemUtil: fullUri ${fullUri}`)
    // const { exists } = await FileSystem.getInfoAsync(
    //   fullUri
    // )
    // return !!exists
  } catch (error) {
    logUtil('').warn(`checking if file exists failed: uri ${uri}, error: `, error)
    throw error
  }
}

export default existsFileSystemUtil
